import { render, staticRenderFns } from "./RequestAffiliationView.vue?vue&type=template&id=39d776d0&"
import script from "./RequestAffiliationView.vue?vue&type=script&lang=ts&"
export * from "./RequestAffiliationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports